import { MenuItem, Select } from '@mui/material';
import GTranslateRoundedIcon from '@mui/icons-material/GTranslateRounded';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const location = useLocation();
    const [lenguage, setlenguage] = useState('en');

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem('lang', lng);
        setlenguage(lng);
    };

    useEffect(() => {
        if (location.pathname === '/login') {
            const language = navigator.language || navigator.userLanguage;
            if (language.includes('es'))
                changeLanguage('es');
            else
                changeLanguage('en');
        }
        else {
            const savedLang = localStorage.getItem('lang') || 'en';
            changeLanguage(savedLang);
        }
    }, [location.pathname]);

    return (
        <Select
            value={lenguage}
            onChange={(e) => changeLanguage(e.target.value)}
            size="small"
            variant="standard"
            disableUnderline
            IconComponent={GTranslateRoundedIcon}
            sx={{
                backgroundColor: 'transparent',
                color: 'white',
                fontSize: 14,
                '& .MuiSelect-select': {
                    paddingRight: '30px !important',
                    minWidth: '16px',
                    marginTop: '5px',
                },
                '& .MuiSelect-icon': {
                    color: 'primary.main',
                    right: '0px',
                    fontSize: '22px',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                },
            }}
        >
            <MenuItem value="es">Español </MenuItem>
            <MenuItem value="en">English </MenuItem>
        </Select >
    );
}
export default LanguageSwitcher;
